import { Col, Row } from "antd";
import React, { FC, Fragment, useState } from "react";
import QuestionModel from "../../../../../models/ExerciseModal/Question.model";
import CKEditorComponent from "../../../../../shared/components/CKEditorComponent";
import CKEditorViewComponent from "../../../../../shared/components/CKEditorViewComponent";
import Option from "./Option";

interface DisplayQuestionProps {
  question: any;
  index: number;
}

const DisplayQuestion: FC<DisplayQuestionProps> = ({ index, question }) => {
  const [viewAllOptions, setViewAllOptions] = useState(false);
  const [viewSolution, setViewSolution] = useState(false);
  return (
    <div className="question__container mt-5">
      <Row align="middle">
        <Col span={1}>{index + 1}</Col>
        <Col span={23}>
          <div>
            <Row>
              {question?.questionAttachments?.map((_, i) => {
                return (
                  <Col span={7}>
                    <img
                      className="attachment__image"
                      src={_.questionAttachmentUrl}
                    />
                  </Col>
                );
              })}
            </Row>
            <CKEditorViewComponent
              value={question?.question || question?.content || ""}
            />
          </div>
        </Col>
      </Row>
      {!question.noOptions && !question.onlyFreeText ? (
        viewAllOptions ? (
          <Fragment>
            <Row className="mt-4" gutter={[15, 15]}>
              {(question?.option1 || question?.image_option1) && (
                <Col span={12}>
                  <Option>
                    {question?.option1 ? (
                      <CKEditorViewComponent value={question?.option1 ?? ""} />
                    ) : question?.image_option1 ? (
                      <img
                        className="attachment__image"
                        src={question?.image_option1}
                      />
                    ) : (
                      "NA"
                    )}
                  </Option>
                </Col>
              )}
              {(question?.option2 || question?.image_option2) && (
                <Col span={12}>
                  <Option>
                    {question?.option2 ? (
                      <CKEditorViewComponent value={question?.option2 ?? ""} />
                    ) : question?.image_option2 ? (
                      <img
                        className="attachment__image"
                        src={question?.image_option2}
                      />
                    ) : (
                      "NA"
                    )}
                  </Option>
                </Col>
              )}
              {(question?.option3 || question?.image_option3) && (
                <Col span={12}>
                  <Option>
                    {question?.option3 ? (
                      <CKEditorViewComponent value={question?.option3 ?? ""} />
                    ) : question?.image_option3 ? (
                      <img
                        className="attachment__image"
                        src={question?.image_option3}
                      />
                    ) : (
                      "NA"
                    )}
                  </Option>
                </Col>
              )}
              {(question?.option4 || question?.image_option4) && (
                <Col span={12}>
                  <Option>
                    {question?.option4 ? (
                      <CKEditorViewComponent value={question?.option4 ?? ""} />
                    ) : question?.image_option4 ? (
                      <img
                        className="attachment__image"
                        src={question?.image_option4}
                      />
                    ) : (
                      "NA"
                    )}
                  </Option>
                </Col>
              )}
            </Row>
          </Fragment>
        ) : (
          <Row className="mt-4">
            <Col span={24}>
              <Option>
                {question?.correctAnswer?.includes("image") ? (
                  <img
                    className="attachment__image"
                    src={question[question?.correctAnswer]}
                  />
                ) : (
                  <CKEditorViewComponent
                    value={question[question?.correctAnswer] ?? ""}
                  />
                )}
              </Option>
            </Col>
          </Row>
        )
      ) : (
        <Row className="mt-2">
          <Col span={24}>
            <p>Free text solution</p>
            <Option>
              <Row>
                {question?.questionSolutionAttachments?.map((_, i) => {
                  return (
                    <Col span={7}>
                      <img
                        className="attachment__image"
                        src={_.questionSolutionAttachmentUrl}
                      />
                    </Col>
                  );
                })}
              </Row>
              <CKEditorViewComponent value={question?.solution ?? ""} />
            </Option>
          </Col>
        </Row>
      )}
      {!question.noOptions && !question.onlyFreeText && (
        <Row className="mt-4">
          <Col span={8}>
            <span
              className="option__button"
              onClick={() => setViewAllOptions((cur) => !cur)}
            >
              {viewAllOptions ? "Hide" : "View"} other options
            </span>
          </Col>
          <Col span={8}>
            <span
              className="solution__button"
              onClick={() => setViewSolution((cur) => !cur)}
            >
              {viewSolution ? "Hide" : "View"} Solution
            </span>
          </Col>
        </Row>
      )}
      {viewSolution && (
        <Row className="mt-2">
          <Col span={24}>
            <p>solution</p>
            <Option>
              <Row>
                {question?.questionSolutionAttachments?.map((_, i) => {
                  return (
                    <Col span={7}>
                      <img
                        className="attachment__image"
                        src={_.questionSolutionAttachmentUrl}
                      />
                    </Col>
                  );
                })}
              </Row>
              <CKEditorViewComponent value={question?.solution ?? ""} />
            </Option>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default DisplayQuestion;
